import React, { useState } from 'react';

import { Button }  from '../components';
import { Container, InputContainer, Input, Imgs, Form, Logomarca } from '../styles';
import { recoverPassword } from '../api';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [responseMessage, setResponseMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setResponseMessage('');

    try {

      const response = await recoverPassword(email);

      const data = await response.json();

      if (response.ok) {
        setResponseMessage('Um e-mail foi enviado com as devidas instruções para a redefinição da sua senha.');

      } else {
        setResponseMessage(data.message || 'Erro ao enviar email de confirmação.');
      }

    } catch (error) {
      setResponseMessage('Erro de rede. Tente novamente mais tarde.');

    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container>
      <InputContainer>
        <Logomarca src={Imgs.logo} alt="Blue House Tennis" width="200px" height="auto" />
        <Form onSubmit={handleSubmit}>
          <h2 style={{color: "white", fontSize: "23px", fontFamily: "Bellota"}}>Esqueceu sua Senha</h2>
          <label style={{color: "white", textAlign: "center", fontSize: "14px"}}>
            Digite o E-mail cadastrado:
            <Input
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{borderBottom: "1px solid white", marginBottom: "40px"}}
            />
          </label>
          <Button title={isLoading ? "Enviando..." : "Enviar e-mail de confirmação"} type="submit" disabled={isLoading}></Button>
          {responseMessage && <p style={{color: "white", textAlign: "center", marginTop: "20px"}}>{responseMessage}</p>}
        </Form>
      </InputContainer>
    </Container>
  );
};

export default ForgotPassword;
